export const settings = {
  url: 'https://openheart.myownwebpage.net/api/v1',
};